import type { ItemsResponse } from '../../../shared/models/api.model';
import { http } from '../../../shared/services/http.service';
import type { ActiveLedgerResponse, LedgerDetail, LedgerSummary } from '../models/ledger.model';

export const ledgerService = {
  list: (): Promise<ItemsResponse<LedgerSummary>> => http.get('/api/ledgers'),
  detail: (ledgerId: string): Promise<LedgerDetail> => http.get(`/api/ledgers/${ledgerId}`),
  create: (name: string): Promise<LedgerDetail> => http.post('/api/ledgers', { name }),
  rename: (ledgerId: string, name: string): Promise<LedgerDetail> =>
    http.patch(`/api/ledgers/${ledgerId}`, { name }),
  remove: (ledgerId: string): Promise<void> => http.delete(`/api/ledgers/${ledgerId}`),
  setActive: (ledgerId: string): Promise<ActiveLedgerResponse> =>
    http.put('/api/me/active-ledger', { ledgerId }),
};
